import { useNosIdQuery } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';

export const getAccountPinsQueryOptions = (sa: string) =>
  queryOptions({
    queryKey: ['accountPins', sa],
    queryFn: () => api.get('/api/v1/services/pins/:serviceId', { params: { serviceId: sa } }),
  });
export function useGetAccountPins(sa: string) {
  return useNosIdQuery(getAccountPinsQueryOptions(sa));
}
